export default __webpack_public_path__ + "static/media/Central-de-Odontologia-de-PortoAlegre.80496e2c.png";